<template>
  <div id="app" class="row vert-offset-top-2">
    <div class="row justify-content-center">
      <div class="col s12 m10 l8 offset-m1 offset-l2">
        <div id="card" class="card col s12 vert-offset-top-1  z-depth-3">
          <div
            class="card-title center padding-top-half padding-bottom-half border-bottom-1 grey-border border-lighten-2"
          >
            <h6 class="grey-text text-darken-2">
              Enter your Contact Details
            </h6>
          </div>
          <div class="card-content col s12">
            <div class="col s12 m9 offset-m1 padding-top-half">
              <div
                class="col s3 m2 l1 vert-offset-top-1 font-16 right-align font-bold"
              >
                +267
              </div>
              <div class="col s9 m10 l11">
                <InputComponent
                  v-model="mobile"
                  type="tel"
                  label="Contact Number"
                  class="validate"
                  required="required"
                  >{{ mobile }}</InputComponent
                >
              </div>
            </div>

            <div
              class="col s12 padding-bottom-half vert-offset-top-2 grey-border border-top-1 border-lighten-3 padding-top-1"
            >
              <div class="col s6 m4 padding-bottom-1 padding-top-1">
                <button
                  type="submit"
                  @click="goback"
                  class="btn btn-small orange darken-1  white-text col s12"
                >
                  Back
                </button>
              </div>
              <div class="col s6 m4 padding-bottom-1 padding-top-1 offset-m4">
                <button
                  type="submit"
                  @click="CheckPatient"
                  class="btn btn-small orange darken-1  white-text col s12"
                  :disabled="isValidMobile"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputComponent from "@/components/materiallize/InputComponent";
import http from "@/http-common";
import { mapState } from "vuex";

export default {
  name: "SelectAssementCenter",
  components: {
    InputComponent
  },
  data() {
    return {
      districts: [],
      centers: [],
      fullname: "",
      mobile: "",
      email: [],
      selected_mobile: null
    };
  },
  computed: {
    isValidMobile: function() {
      return (
        typeof this.mobile !== "undefined" &&
        this.mobile !== null &&
        this.mobile.length <= 6
      );
    },
    ...mapState({
      stateSelectedDistrict: state => state.selectedDistrict,
      stateSelectedCenter: state => state.selectedCenter,
      stateSelectedLocation: state => state.selectedLocation,
      stateSelectedServices: state => state.selectedServices,
      stateSelectedDate: state => state.date,
      stateSelectedMobile: state => state.mobile
    }),
    stateHasSelectedDate: function() {
      return (
        typeof this.stateSelectedDate !== "undefined" &&
        this.stateSelectedDate !== null
      );
    },
    stateHasSelectedDistrict: function() {
      return (
        typeof this.stateSelectedDistrict !== "undefined" &&
        this.stateSelectedDistrict !== null
      );
    },
    stateHasSelectedLocation: function() {
      return (
        typeof this.stateSelectedLocation !== "undefined" &&
        this.stateSelectedLocation !== null
      );
    },
    stateHasSelectedCenter: function() {
      return (
        typeof this.stateSelectedCenter !== "undefined" &&
        this.stateSelectedCenter !== null
      );
    },
    stateHasSelectedServices: function() {
      return (
        typeof this.stateSelectedServices !== "undefined" &&
        this.stateSelectedServices !== null
      );
    },
    stateHasSelectedMobile: function() {
      return (
        typeof this.stateSelectedMobile !== "undefined" &&
        this.stateSelectedMobile !== null
      );
    }
  },
  methods: {
    goto() {
      this.$store.dispatch("SET_CREATE_PATIENT", false);
      this.$router.push("/book");
    },
    goback() {
      this.$router.push("/reason");
    },
    adddetails() {
      this.$store.dispatch("SET_CREATE_PATIENT", true);
      this.$router.push("/patientdetails");
    },
    CheckPatient() {
      this.$store.dispatch("START_PROCESSING");
      return new Promise(resolve => {
        http({
          url: "/api/patient/check",
          data: {
            country: this.countries,
            mobile: this.mobile
          },
          method: "POST",
          timeout: 30000
        })
          .then(response => {
            this.$store.dispatch("STOP_PROCESSING");
            this.$store.dispatch("SET_MOBILE", this.mobile);
            if (response.data.data === true) {
              this.goto();
            } else {
              this.adddetails();
            }
            resolve(response);
          })
          .catch(response => {
            this.$store.dispatch("STOP_PROCESSING");
            this.$store.dispatch("GET_MESSAGES", response.data.message);
            resolve(response);
          });
      });
    },

    beforeCreate() {
      this.$store.commit("initialiseStore");
    },
    mustRedirectHome: function() {
      if (
        !this
          .stateHasSelectedCenter /*|| !this.stateHasSelectedDistrict*/ /*|| ! this.stateHasSelectedLocation*/ ||
        !this.stateHasSelectedServices /*|| !this.stateHasSelectedMobile*/
      ) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    if (this.stateHasSelectedMobile) {
      this.mobile = this.stateSelectedMobile;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-kerning: normal;
}
</style>
